import ActivityCounter from './ActivityCounter';

export default ActivityCounter;
